var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    transform: "translate(-0.1 -0.1)",
    fill: "none",
    stroke: "#11ff64",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_552",
    "data-name": "Trac\\xE9 552",
    d: "M3.64,2.343H5.892V-.7h3.04V-2.948H5.892v-3.04H3.64v3.04H.6V-.7H3.64Z",
    transform: "translate(6.134 13.042)",
    fill: "#11ff64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.101f7bae28dbf02b8d734a962de66944.svg";
export { ForwardRef as ReactComponent };